import { createContext, useContext } from 'react';

import type { RefObject } from 'react';

export const MainContentRefContext = createContext<React.RefObject<HTMLDivElement | null> | null>(
    null,
);

export function useMainContentRef(): RefObject<HTMLDivElement | null> | null {
    return useContext(MainContentRefContext);
}
